import { Component } from '@angular/core';
import { AbstractFormWidgetComponent } from '../../../../../shared/components/widget/abstract-form-widget/abstract-form-widget.component';
import { ResourceService } from 'sce-core';
import { NavigationService } from '../../../../../core/navigation.service';
import { AlertService } from 'sce-core';
import { UserService } from '../../../../../core/security/user.service';
import { LeftPanelService } from '../../../../../layout/home/services/left-panel.service';
import { DatePickerConfigService } from '../../../../../shared/components/datepicker/datepicker-config.service';


@Component({
  selector: 'lfwms-pack-search',
  templateUrl: './pack-secondary-accordian.component.html',
  styleUrls: ['./pack-secondary-accordian.component.css']
})
export class PackSecondaryAccordianComponent extends AbstractFormWidgetComponent {

  constructor(protected resourceService: ResourceService,
    protected navService: NavigationService,
    protected leftPanelService: LeftPanelService,
    protected alertService: AlertService,
    protected userService: UserService,
    protected dateConfigService: DatePickerConfigService) {
    super(resourceService, navService, leftPanelService, alertService, userService, dateConfigService);
  }

  protected initializeWidget() {
    super.initializeWidget();
    //LFWM-3490, for replenishUOM3, defaultCheckVal is set as default value from db
    if (this.dataService.displayMode === 'C' && this.metadataMap['replenishUOM3'] && this.metadataMap['replenishUOM3'].defaultVal) {
      this.cellDataMap['replenishUOM3'].cVal = this.metadataMap['replenishUOM3'].defaultVal;
    }
    this.propertyList = this.widgetConfig.propertyList;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/setup/customer/pack/pack-secondary-accordian/pack-secondary-accordian.component.ts